import { render, staticRenderFns } from "./LogBook.vue?vue&type=template&id=410cdd26"
import script from "./LogBook.vue?vue&type=script&lang=js"
export * from "./LogBook.vue?vue&type=script&lang=js"
import style0 from "./LogBook.vue?vue&type=style&index=0&id=410cdd26&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports